import React from 'react'
import Lottie from 'react-lottie'
import { useWhiteLabel } from 'src/white-label'

export default function RocketInfinite(props: any) {
  const { infiniteAnimationData: InfiniteAnimationData } = useWhiteLabel()

  const defaultOptions = {
    loop: true,
    autoplay: false,
    animationData: InfiniteAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div>
      <Lottie
        options={defaultOptions}
        speed={props.speed}
        height={props.height}
        width={props.width}
        isPaused={props.isPaused}
        isClickToPauseDisabled={true}
        isStopped={props.isStopped}
      />
    </div>
  )
}
